
/**
 * 
 * https://app.contentstack.com/#!/stack/bltf59a0f025a7625f9/content-type/information/en-us/entry/blt88524fdc5548c902/edit?branch=main
 * https://app.contentstack.com/#!/stack/bltf59a0f025a7625f9/content-type/product_sku/zh-tw/entry/blta73836925fe2147f/edit?branch=main
 * https://app.contentstack.com/#!/stack/bltf59a0f025a7625f9/content-type/product_sku/content-type-builder?branch=main
 * 
*/
{/* TEP-16974 不可販售商品能在搜尋引擎上搜索到並可下單 start */ }
import Breakpoint from "@tw/style-guide/lib/components/utilities/breakpoint";
import PropTypes from 'prop-types';
import React, { useEffect, useState, useMemo } from 'react';
import Background from "../Background/Background";
import BottomDrawer from "../bottomDrawer/bottomDrawer";
import ModalWrapper from "../ModalWrapper/ModalWrapper";
import styles from "./index.scss";
const Index = props => {
  const {
    itemCode,
    modalData,
    modalWidth,
    modalHeight,
    onClose
  } = props;
  const [openModal, setOpenModal] = useState(false)
  const [breakpoint, setBreakpoint] = useState("xs");
  const isDesktop = breakpoint !== "xs" && breakpoint !== "sm";
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    if (
      typeof window !== undefined &&
      typeof window !== "undefined" &&
      modalData &&
      modalData.switch !== undefined
    ) {
      setOpenModal(modalData?.switch)
    }
  }, [modalData])

  useEffect(() => {
    let animationFrameId = null; // 用于存储 requestAnimationFrame 的 ID，以便后续清除
    let isMounted = true; // 用于标识组件是否已挂载，防止在组件卸载后更新状态

    // 打开模态框时的处理函数
    const handleOpenModal = () => {
      // 禁止页面滚动（避免背景滚动影响用户体验）
      document.body.style.overflow = 'hidden';

      // 使用 requestAnimationFrame 来确保动画在下一帧渲染前触发，提升流畅度
      animationFrameId = requestAnimationFrame(() => {
        if (isMounted) setIsVisible(true); // 触发动画显示
      });
    };

    // 关闭模态框时的处理函数
    const handleCloseModal = () => {
      // 恢复页面滚动
      document.body.style.overflow = '';
      setIsVisible(false); // 隐藏模态框内容
    };

    // 根据 openModal 的值决定执行打开还是关闭逻辑
    if (openModal) {
      handleOpenModal();
    } else {
      handleCloseModal();
    }

    // 清理副作用
    return () => {
      isMounted = false; // 组件即将卸载，设置为 false 防止状态更新
      document.body.style.overflow = ''; // 恢复页面滚动
      if (animationFrameId) cancelAnimationFrame(animationFrameId); // 清除未执行的动画帧任务
    };
  }, [openModal]); // 只有当 openModal 发生变化时才重新执行该副作用
  /**
   * 确认按钮点击事件处理函数
   * 该函数根据提供的href链接地址，决定是进行页面跳转还是关闭当前项
   * @param {string} href - 链接地址，用于判断是否执行页面跳转
   */
  const onConfirmButton = (href) => {
    // 检查href是否存在
    if (href) {
      // 根据href是否包含查询字符串，来决定如何构造重定向URL
      let redirectUrl = href + (window.location.search ? (href.includes('?') ? '&' : '?') + window.location.search.slice(1) : '');
      // 执行页面跳转
      window.location.href = redirectUrl
      // 结束函数执行
      return;
    } else {
      // 如果没有href，则执行关闭操作
      close(itemCode)
      // 结束函数执行
      return;
    }
  }
  // 關閉彈窗回調
  const close = (itemCode) => {
    onClose(itemCode)
    setOpenModal(false)
  }
  // 提示图片的 style 属性
  const imageStyle = useMemo(() => ({
    width: modalData?.content ? (isDesktop ? 44 : 22) : '100%',
    marginRight: modalData?.content ? (isDesktop ? 0 : 10) : 0
  }), [isDesktop, modalData?.content]);

  //  按钮的 style 属性
  const cancelButtonStyle = useMemo(() => ({
    maxWidth: isDesktop ? '310px' : 'auto',
    marginRight: modalData?.confirmButton?.show ? '10px' : '0',
    background: modalData?.cancelButton?.backgroundColor,
    color: modalData?.cancelButton?.textColor,
    borderColor: modalData?.cancelButton?.borderColor,
  }), [isDesktop, modalData]);

  //  按钮的 style 属性
  const confirmButtonStyle = useMemo(() => ({
    maxWidth: isDesktop ? '310px' : 'auto',
    marginLeft: modalData?.cancelButton?.show ? '10px' : '0',
    background: modalData?.confirmButton?.backgroundColor,
    color: modalData?.confirmButton?.textColor,
    borderColor: modalData?.confirmButton?.borderColor,
  }), [isDesktop, modalData]);


  return (
    <>
      <Breakpoint onBreakpointChange={setBreakpoint} />
      {
        isDesktop ?
          openModal &&
          <Background>
            <div
              className={`${styles.modalContainer} ${isVisible ? styles.modalEnter : ""}`}
            >
              <ModalWrapper modalWidth={modalWidth}>
                <div className={styles.header_PC} style={{ border: !modalData?.title && !modalData?.showCloseIcon && 'none' }}>
                  <div className={styles.header_left}>{modalData?.title}</div>
                  {
                    modalData?.showCloseIcon && <div className={styles.header_right} onClick={() => close(itemCode)}><CloseIcon /></div>
                  }
                </div>
                <div className={styles.ProductsPromptModal}>
                  <div className={styles.ProductsPromptModal_Scroll_Content}>
                    {
                      modalData?.contentIcon &&
                      <div className={styles.ProductsPromptModal_Content_Icon} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: modalData?.content && 25 }}>
                        <img src={modalData?.contentIcon} style={imageStyle} alt="" />
                      </div>
                    }
                    {
                      modalData?.content && <div dangerouslySetInnerHTML={{ __html: modalData?.content }}></div>
                    }
                  </div>
                  <ModalFooter
                    cancelButton={modalData?.cancelButton}
                    confirmButton={modalData?.confirmButton}
                    onCancel={() => close(itemCode)}
                    onConfirm={() => onConfirmButton(modalData?.confirmButton?.href)}
                    cancelButtonStyle={cancelButtonStyle}
                    confirmButtonStyle={confirmButtonStyle}
                  />
                </div>
              </ModalWrapper>
            </div>

          </Background>
          :
          <BottomDrawer open={openModal} showCloseIcon={modalData?.showCloseIcon} setOpen={() => modalData?.showCloseIcon ? close(itemCode) : null}>
            <div className={styles.header_Mobile} style={{ height: modalHeight, border: !modalData?.title && !modalData?.showCloseIcon && 'none' }}>
              <div className={styles.header_left}>{modalData?.title}</div>
              {
                modalData?.showCloseIcon && <div className={styles.header_right}></div>
              }
            </div>
            <div className={styles.ProductsPromptModal}>
              <div className={styles.ProductsPromptModal_Scroll_Content}>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  {
                    modalData?.contentIcon &&
                    <div
                      className={styles.ProductsPromptModal_Content_Icon}
                      style={{ flex: !modalData?.content && 1, textAlign: 'center' }}
                    >
                      <img src={modalData?.contentIcon} style={imageStyle} alt="" />
                    </div>
                  }
                  {
                    modalData?.content && <div className={styles.ProductsPromptModal_Content_children} style={{ flex: 1 }} dangerouslySetInnerHTML={{ __html: modalData?.content }}></div>
                  }
                </div>
              </div>
              <ModalFooter
                cancelButton={modalData?.cancelButton}
                confirmButton={modalData?.confirmButton}
                onCancel={() => close(itemCode)}
                onConfirm={() => onConfirmButton(modalData?.confirmButton?.href)}
                cancelButtonStyle={cancelButtonStyle}
                confirmButtonStyle={confirmButtonStyle}
              />
            </div>
          </BottomDrawer>
      }
    </>
  );
};
//API
Index.defaultProps = {
  // 商品編號
  itemCode: null,
  // 彈出窗資料
  modalData: null,
  //  PC 彈出窗寬度
  modalWidth: "460px",
  //  彈出窗寬度
  modalHeight: "",
  //  关闭按钮回调
  onClose: () => { }
};

//參數類型
Index.propTypes = {
  itemCode: PropTypes.string,
  modalWidth: PropTypes.string,
  modalHeight: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  modalData: PropTypes.shape({
    switch: PropTypes.bool,  // 是否顯示彈窗框
    title: PropTypes.string,  //  商品彈出框上的標題文字
    contentIcon: PropTypes.string, // 商品彈出框關閉圖標
    content: PropTypes.string, // 商品彈出框描述內容
    showCloseIcon: PropTypes.bool, // 是否顯示關閉圖標
    cancelButton: PropTypes.shape({ //  取消按鈕
      show: PropTypes.bool,
      title: PropTypes.string,
      backgroundColor: PropTypes.string,
      textColor: PropTypes.string,
      borderColor: PropTypes.string,
    }),
    confirmButton: PropTypes.shape({ //  確認按鈕
      show: PropTypes.bool,
      title: PropTypes.string,
      href: PropTypes.string,
      backgroundColor: PropTypes.string,
      textColor: PropTypes.string,
      borderColor: PropTypes.string,
    }),
  }).isRequired,
};
export default Index;
{/* TEP-16974  End */ }
/**
 * 弹出框右上角关闭图标
 */
const CloseIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.3473 11.9752L19.7165 6.60598C20.027 6.29545 20.027 5.79153 19.7165 5.4805L18.4689 4.2329C18.1584 3.92237 17.6545 3.92237 17.3434 4.2329L11.9747 9.60262L6.60548 4.2334C6.29495 3.92287 5.79103 3.92287 5.48 4.2334L4.2329 5.4805C3.92237 5.79103 3.92237 6.29495 4.2329 6.60598L9.60212 11.9752L4.2329 17.3444C3.92237 17.655 3.92237 18.1589 4.2329 18.4699L5.4805 19.7175C5.79103 20.028 6.29495 20.028 6.60598 19.7175L11.9747 14.3478L17.3439 19.717C17.6545 20.0275 18.1584 20.0275 18.4694 19.717L19.717 18.4694C20.0275 18.1589 20.0275 17.655 19.717 17.3439L14.3473 11.9752Z" fill="#2C2C2C" />
  </svg>
)
/**
 * 自定义模态框底部组件
 * 
 * 该组件根据传入的属性决定是否显示取消和确认按钮，以及如何布局和样式化这些按钮
 * 主要用于在模态框中提供用户操作的选项，如确认或取消操作
 * 
 * @param {Function} onCancel - 点击取消按钮时调用的回调函数
 * @param {Function} onConfirm - 点击确认按钮时调用的回调函数
 * @param {Object} cancelButton - 取消按钮的配置对象，包含按钮的显示控制和标题等信息
 * @param {Object} confirmButton - 确认按钮的配置对象，包含按钮的显示控制和标题等信息
 */
const ModalFooter = ({ onCancel, onConfirm, cancelButton, confirmButton, cancelButtonStyle, confirmButtonStyle }) => (
  <div className={styles.ProductsPromptModal_Footer} style={{
    // 根据是否有按钮显示，条件性地应用边框样式和高度
    border: !cancelButton?.show && !confirmButton?.show && 'none',
    height: !cancelButton?.show && !confirmButton?.show && (isDesktop ? '44px' : '22px')
  }}>
    {cancelButton?.show && (
      // 渲染取消按钮，并绑定取消操作的回调函数
      <div className={styles.agreed_Btn} style={cancelButtonStyle} onClick={onCancel}>
        {cancelButton.title}
      </div>
    )}
    {confirmButton?.show && (
      // 渲染确认按钮，并绑定确认操作的回调函数
      <div className={styles.agreed_Btn} style={confirmButtonStyle} onClick={onConfirm}>
        {confirmButton.title}
      </div>
    )}
  </div>
);
